module.exports = __webpack_public_path__ + "static/media/ribbon3.e8f9fb30.svg";